'use client';

import { c as _c } from "react/compiler-runtime";
import type { Address, ChainId } from '@morpho-org/blue-sdk';
import { parseApiAsset } from '@morpho-org/dapp-core';
import RewardsHoverCard from '@/components/common/RewardsHoverCard';
import { vaultIncludesDonations } from '@/config/donation-vaults';
import { getParsedValue } from '@/helpers/formatters';
import { useVaultV2Apy } from '@/hooks/useVaultV2Apy';
import type { VaultV2ApyOverviewData } from '../VaultV2ApyOverview.mapper';
interface V2RateCardProps {
  apyOverview: VaultV2ApyOverviewData;
  vaultAddress: Address;
  chainId: ChainId;
  isRateCapped: boolean;
}
const V2RateCard = t0 => {
  const $ = _c(28);
  const {
    apyOverview,
    vaultAddress,
    chainId,
    isRateCapped
  } = t0;
  let t1;
  if ($[0] !== apyOverview.asset) {
    t1 = getParsedValue(apyOverview.asset, parseApiAsset);
    $[0] = apyOverview.asset;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const asset = t1;
  let t2;
  if ($[2] !== apyOverview.address || $[3] !== apyOverview.apyBreakdown || $[4] !== apyOverview.asset || $[5] !== apyOverview.managementFee || $[6] !== apyOverview.maxApy || $[7] !== apyOverview.netApy || $[8] !== apyOverview.netApyExcludingRewards || $[9] !== apyOverview.performanceFee || $[10] !== apyOverview.rewards) {
    t2 = {
      vaultV2: {
        address: apyOverview.address,
        asset: apyOverview.asset,
        performanceFee: apyOverview.performanceFee,
        managementFee: apyOverview.managementFee,
        netApyExcludingRewards: apyOverview.netApyExcludingRewards,
        netApy: apyOverview.netApy,
        apyBreakdown: apyOverview.apyBreakdown,
        maxRate: apyOverview.maxApy,
        rewards: apyOverview.rewards
      }
    };
    $[2] = apyOverview.address;
    $[3] = apyOverview.apyBreakdown;
    $[4] = apyOverview.asset;
    $[5] = apyOverview.managementFee;
    $[6] = apyOverview.maxApy;
    $[7] = apyOverview.netApy;
    $[8] = apyOverview.netApyExcludingRewards;
    $[9] = apyOverview.performanceFee;
    $[10] = apyOverview.rewards;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  const {
    apy,
    netApy,
    performanceFee,
    managementFee,
    maxRate,
    points,
    rewards
  } = useVaultV2Apy(t2);
  const t3 = apyOverview.maxApy;
  let t4;
  if ($[12] !== chainId || $[13] !== vaultAddress) {
    t4 = vaultIncludesDonations(chainId, vaultAddress);
    $[12] = chainId;
    $[13] = vaultAddress;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] !== apy || $[16] !== apyOverview.apyBreakdown || $[17] !== apyOverview.maxApy || $[18] !== asset || $[19] !== isRateCapped || $[20] !== managementFee || $[21] !== maxRate || $[22] !== netApy || $[23] !== performanceFee || $[24] !== points || $[25] !== rewards || $[26] !== t4) {
    t5 = <div className="border-border bg-muted py-md px-md w-[275px] overflow-y-auto rounded-[20px] border-[0.5px] max-lg:max-h-[345px] max-lg:w-full max-lg:rounded-none max-lg:border-none max-lg:bg-transparent max-lg:p-0"><RewardsHoverCard rewards={rewards} apy={apy} netApy={netApy} performanceFee={performanceFee} managementFee={managementFee} variant="vault" points={points} asset={asset} maxRate={maxRate} maxApy={t3} isRateCapped={isRateCapped} includesDonations={t4} apyBreakdown={apyOverview.apyBreakdown} hideNetApyHeader={true} /></div>;
    $[15] = apy;
    $[16] = apyOverview.apyBreakdown;
    $[17] = apyOverview.maxApy;
    $[18] = asset;
    $[19] = isRateCapped;
    $[20] = managementFee;
    $[21] = maxRate;
    $[22] = netApy;
    $[23] = performanceFee;
    $[24] = points;
    $[25] = rewards;
    $[26] = t4;
    $[27] = t5;
  } else {
    t5 = $[27];
  }
  return t5;
};
export default V2RateCard;